import React from 'react';

import DashboardFunctional from './component/dashboard-functional';

export const Dashboard = () => {
	return <DashboardFunctional />;
};
